var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTasks = function SvgTasks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.609 3H3.392a.39.39 0 0 0-.391.39v15.184a.39.39 0 0 0 .391.391h15.217a.39.39 0 0 0 .391-.389V3.392A.39.39 0 0 0 18.609 3zm-.39 15.184H3.781v-14.4H18.22v14.405zM9.812 7.614h5a.39.39 0 1 0 0-.779h-5a.39.39 0 0 0 0 .78zm-2.362.459a.85.85 0 1 0-.85-.85.85.85 0 0 0 .85.85zm2.362 3.3h5a.39.39 0 1 0 0-.779h-5a.39.39 0 0 0 0 .78zm-2.362.459a.85.85 0 1 0-.85-.85.85.85 0 0 0 .85.85zm2.362 3.3h5a.39.39 0 1 0 0-.779h-5a.39.39 0 0 0 0 .779zm-2.362.459a.85.85 0 1 0-.85-.85.85.85 0 0 0 .85.85z",
    "data-name": "header-icon-work order"
  })));
};
export default SvgTasks;